/**
 * Flat list of steps across every admin page, in walkthrough order. Each step's
 * `page` is the route it belongs to — AdminTour navigates there automatically
 * when Next/Back crosses a page boundary, so the tour reads as one continuous
 * walkthrough instead of resetting each time you land on a new admin page.
 */
const tourSteps = [
  {
    page: '/admin/rules',
    target: 'rules-game-rules',
    title: 'Game rules',
    description: 'Add up to 6 rules shown to players before they start. At least one is required.',
  },
  {
    page: '/admin/rules',
    target: 'rules-colors',
    title: 'Colors',
    description: 'Set the page text color and the box text color used across the rules, lobby, and canvas pages.',
  },
  {
    page: '/admin/rules',
    target: 'rules-live-session',
    title: 'Live session controls',
    description: 'Set the lobby wait time (minutes + seconds), then Start or Skip the countdown for players currently waiting in THIS live session.',
  },
  {
    page: '/admin/rules',
    target: 'rules-save',
    title: 'Save rules',
    description: 'Save takes you to the Canvas settings page next — continue there to finish setting up this theme.',
  },
  {
    page: '/admin/themeupdate',
    target: 'theme-game-mode',
    title: 'Game mode',
    description: 'Live keeps every player synced to the same countdown. Self-Paced lets each player go at their own speed. Download controls whether players can save the finished artwork.',
  },
  {
    page: '/admin/themeupdate',
    target: 'theme-timer',
    title: 'Drawing timer',
    description: 'Only shown in Live mode — set how long players get to draw, in minutes and seconds.',
  },
  {
    page: '/admin/themeupdate',
    target: 'theme-images',
    title: 'Canvas images',
    description: 'Upload the outline image players draw on, and the coloured master image used as the reference and for auto-filling unfinished tiles.',
  },
  {
    page: '/admin/themeupdate',
    target: 'theme-pieces',
    title: 'Canvas pieces',
    description: 'Choose how many pieces to split the canvas into — anywhere from 1 up to 100.',
  },
  {
    page: '/admin/themeupdate',
    target: 'theme-save',
    title: 'Save puzzle settings',
    description: 'Save to finish. That’s the whole setup — you’re done!',
  },
];

export default tourSteps;
